import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatBadgeModule } from '@angular/material/badge';
import { MatButtonModule } from '@angular/material/button';
import { MatRippleModule } from '@angular/material/core';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideStates } from '@ngxs/store';
import { CheckoutApiService } from '@pages/checkout-page/services/checkout-api.service';
import { FlightClassComponent } from '@shared/components/flight-class/flight-class.component';
import { StarsComponent } from '@shared/components/stars/stars.component';
import { DynamicModalModule } from '@shared/modules/dynamic-modal/dynamic-modal.module';
import { OrNullPipe } from '@shared/pipes/or-null.pipe';
import { RunFunctionPipe } from '@shared/pipes/run-function.pipe';
import { SnakeCasePipe } from '@shared/pipes/snake-case.pipe';
import { ConfirmModule } from '../confirm/confirm.module';
import { DynamicOverlayModule } from '../dynamic-overlay/dynamic-overlay.module';
import { CartContentViewComponent } from './components/cart-content-view/cart-content-view.component';
import { CartHeaderButtonComponent } from './components/cart-header-button/cart-header-button.component';
import { CartAviaItemViewComponent } from './components/items/cart-avia-item-view/cart-avia-item-view.component';
import { CartHotelItemViewComponent } from './components/items/cart-hotel-item-view/cart-hotel-item-view.component';
import { CartTourItemViewComponent } from './components/items/cart-tour-item-view/cart-tour-item-view.component';
import { CartState } from './state/cart.state';

@NgModule({
  imports: [
    CommonModule,
    StarsComponent,
    FlightClassComponent,
    MatBadgeModule,
    MatButtonModule,
    MatIconModule,
    DynamicModalModule,
    MatRippleModule,
    MatSnackBarModule,
    OrNullPipe,
    RunFunctionPipe,
    SnakeCasePipe,
    DynamicOverlayModule,
    ConfirmModule,
    MatProgressBarModule,
    CartAviaItemViewComponent,
    CartContentViewComponent,
    CartHeaderButtonComponent,
    CartHotelItemViewComponent,
    CartTourItemViewComponent
  ],
  exports: [CartHeaderButtonComponent],
  providers: [CheckoutApiService, provideStates([CartState])]
})
export class CartModule {}
